<template>
  <div class="popup" @mousedown.self="$emit('close')">
    <div class="popup-content">
      <h3>{{titre}}</h3>
      <hr />
      <div class="preview-container">
        <div v-html="corps" class="preview">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CmsPreview',
    props: {
      titre: String, //Titre de l'article
      corps: String //Corps de la catégorie
    },
  };
</script>


<style>
  .popup {
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(155, 155, 155, 0.8);
  }

    .popup > .popup-content {
      margin: 70px auto;
      padding: 20px;
      background: #fff;
      border-radius: 5px;
      width: 80%;
      max-height: 90%;
      overflow:auto;
      position: relative;
    }
    .preview-container{
        width: 100%;
        display:flex;
        justify-content:center;
    }
  .preview{
      width: 95%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cms/CmsPreview.vue